import { type OrderDto } from '../types/OrderDto';
import { OrderDeliveryMethods } from './OrderDeliveryMethods';
import { OrderDeliveryServices } from './OrderDeliveryServices';
import { OrderPaymentMethods } from './OrderPaymentMethods';
import { OrderStatuses } from './OrderStatuses';

export const DEFAULT_ORDER: OrderDto = {
    id: '',
    acquiring_id: '',
    created_at: '1970-01-01T00:00:00Z',
    order_number: '0',
    status: OrderStatuses.NEW,
    total_final_price: '0.00',
    total_price: '0.00',
    client: {
        last_name: '',
        first_name: '',
        phone: '',
        email: '',
        agreement_personal_data: true,
        is_notify: false,
        need_ozon_registration: false,
        need_phone_verification: false,
    },
    payment: {
        method: OrderPaymentMethods.CARD_ONLINE,
        status: '',
    },
    delivery: {
        customer_costs: '0.00',
        final_customer_costs: '0.00',
        raw_status: OrderStatuses.NEW,
        method: OrderDeliveryMethods.COURIER,
        address: {
            address: '',
            pickup_point_id: '',
            appartment: '',
            entrance: '',
            floor: '',
            intercom: '',
            locality: '',
            courier_locality: '',
            courier_address: '',
            pickup_point_locality: '',
            pickup_point_address: '',
            self_pick_up_warehouse_id: '',
            self_pick_up_address: '',
            self_pick_up_locality: '',
        },
        delivery_notes: '',
        pickup_point_delivery_service_type: OrderDeliveryServices.YANDEX_DELIVERY,
        courier_delivery_service_type: OrderDeliveryServices.YANDEX_DELIVERY,
        track_number: '',
    },
    delivery_chunks: [],
    available_items_quantity: 0,
    related_services_info: {
        editable: false,
        enabled: false,
        is_available_region: false,
    },
};
